import axios from 'axios'
import { Message } from 'element-ui';
// import store from '@/store'
//创建axios的一个实例 
// 环境自动判断：页面域名含 test 或本地运行 → 测试；正式域名(不含test) → 正式。打一次包正式/测试通用，本地默认测试。
function isTestEnv() {
    var h = (typeof location !== 'undefined' && location.hostname) || '';
    return !h || /test/i.test(h) || h === 'localhost' || h === '127.0.0.1' || /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(h);
}
var instance = axios.create({
    baseURL: isTestEnv() ? "https://testawegzapi.zhiandexpo.com" : "https://awegzapi.zhiandexpo.com",
    timeout: 1000 * 60
})

//------------------- 一、请求拦截器
instance.interceptors.request.use((config) => {
    // console.log(store.state.user)
    let token = localStorage.getItem("token_leader")
    if (token){
        config.headers['Authorization'] = token
        // config.headers['Authorization'] = "bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sZWFkZXIuY29tXC9hcGlcL2xvZ2luIiwiaWF0IjoxNjIzNzM2NzEyLCJleHAiOjE2MjYzMjg3MTIsIm5iZiI6MTYyMzczNjcxMiwianRpIjoiSThLUXZNcjBHSElteDZtOCIsInN1YiI6MSwicHJ2IjoiZGY4ODNkYjk3YmQwNWVmOGZmODUwODJkNjg2YzQ1ZTgzMmU1OTNhOSJ9.e22kNUQD4tE0KQjUn8FYNe8OdoobEBzYUdt73s8cXag";
    } else {
        config.headers['Authorization'] = "";
    }
    return config;
}, (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
});

//----------------- 二、响应拦截器
instance.interceptors.response.use((response) => {
    const res = response.data;
    // 安全整改：后端对报名查询接口做归属校验，未登录/非本人会返回 401/403，提示文案由后端返回
    if (res && (res.code == 401 || res.code == 403)) {
        Message.error(res.msg);
    }
    return res;
}, (error) => {
    console.log(error)
    // 对响应错误做点什么
    console.log('拦截器报错');
    console.log(error.message.includes('timeout'))
    if(error.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
        Message.error('网络超时，请尝试减少表格中的行数')
        return Promise.reject(error);          // reject这个错误信息
    } else {
        Message.error('网络连接失败，请稍后再试')
        return Promise.reject(error);

    }
    // return Promise.reject(error);
});

export default instance;


// WEBPACK FOOTER //
// ./src/utils/http.js